import { Flex } from '@chakra-ui/react';

import { AutoCompleteInputItemProps } from './AutoCompleteInput.types';

export const AutoCompleteInputItem = ({ children, value }: AutoCompleteInputItemProps) => {
  if (value === undefined || value === null) return null;

  return (
    <Flex
      tabIndex={-1}
      gap='2'
      p='2'
      width='full'
      justifyContent={'flex-start'}
      borderRadius='none'
      _hover={{
        backgroundColor: 'brand.100',
      }}
    >
      {children}
    </Flex>
  );
};

AutoCompleteInputItem.displayName = 'AutoCompleteInputItem';
